import { usePage } from '@inertiajs/react';

// Market pages live at /<eventSlug>/market/... so the event the client should query is
// the first path segment. C5 keeps those URLs identical to the Next ones, so the segment
// is always there; the Next hook's fallback to CURRENT_EVENT.slug guarded a shallower
// path that no market route can produce.
export function useEventSlug(): string {
  const { url } = usePage();
  return url.split('?')[0].split('/').filter(Boolean)[0] ?? '';
}
